import "../css/header.css";

function Header() {
  return (
    <div className="Header">
      <div className="logo">
        <img src="/logo.svg" alt="logo" />
      </div>
    </div>
  );
}

export default Header;
